export default __webpack_public_path__ + "static/media/web.421b3978.jpeg";